import React from 'react';
import { InformationalCallOut } from '@grnhse/seedling/lib/birch/components/call_out';
import { withLocalePrefix } from 'shared/utils/translation';
import { Body } from '@grnhse/seedling/lib/birch/typography';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack_v2';

const t = withLocalePrefix(
  'bulk_actions.modal.emails.bulk_rejection_email.callout'
);

// This string must be kept in sync with the list in /app/views/people/show/rejection_modal_body/_content.html.erb
const UNUSED_TOKENS =
  '{{START_DATE}}, {{APPLIED_DATE}}, {{INTERVIEW_SCHEDULE}}, {{INTERVIEW_SCHEDULE_START_TIME}}';

const BulkRejectionCallout = () => {
  return (
    <InformationalCallOut
      headerText={t('no_application_tokens')}
      bodyText={
        <Stack>
          <Body>
            {t('all_custom_tokens')} {UNUSED_TOKENS}
          </Body>
        </Stack>
      }
    />
  );
};

export default BulkRejectionCallout;
